import React from "react";

export default function Status({
  size = 20,
  ...rest
}: {
  size?: number;
  [x: string]: any;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x="0.5"
        y="0.5"
        width="19"
        height="19"
        rx="9.5"
        fill="#191D29"
        stroke="url(#paint0_linear_1819_4286)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9218 6.09864C10.2353 5.94949 9.52068 5.96976 8.84456 6.15755C8.17058 6.34475 7.55678 6.69233 7.06005 7.16801L5.83333 8.27487V6.79918C5.83333 6.57822 5.64678 6.39909 5.41666 6.39909C5.18655 6.39909 5 6.57822 5 6.79918V9.19975C5 9.42072 5.18655 9.59985 5.41666 9.59985H5.6122C5.61225 9.59988 5.6123 9.5999 5.61235 9.5999C5.61242 9.59991 5.61249 9.59989 5.61256 9.59985H7.91664C8.14676 9.59985 8.3333 9.42072 8.3333 9.19975C8.3333 8.97879 8.14676 8.79966 7.91664 8.79966H6.46865L7.63533 7.74697L7.64471 7.73824C8.04276 7.35582 8.53521 7.07646 9.0761 6.92623C9.617 6.776 10.1887 6.75978 10.7379 6.8791C11.2871 6.99842 11.7959 7.24939 12.2167 7.60858C12.6376 7.96777 12.9568 8.42348 13.1447 8.93319C13.2214 9.14149 13.4595 9.2506 13.6764 9.17689C13.8934 9.10318 14.007 8.87455 13.9302 8.66625C13.6954 8.02911 13.2964 7.45947 12.7703 7.01048C12.2442 6.5615 11.6083 6.24779 10.9218 6.09864ZM13.5314 11.2003H12.0834C11.8533 11.2003 11.6667 11.0211 11.6667 10.8002C11.6667 10.5792 11.8533 10.4001 12.0834 10.4001H14.5834C14.8135 10.4001 15.0001 10.5792 15.0001 10.8002V13.2007C15.0001 13.4217 14.8135 13.6008 14.5834 13.6008C14.3533 13.6008 14.1667 13.4217 14.1667 13.2007V11.725L12.9399 12.832C12.4432 13.3077 11.8294 13.6553 11.1554 13.8424C10.4793 14.0302 9.76464 14.0505 9.07816 13.9014C8.39167 13.7522 7.75572 13.4385 7.22965 12.9895C6.70357 12.5405 6.30452 11.9709 6.06972 11.3338C5.99296 11.1254 6.10659 10.8968 6.32352 10.8231C6.54045 10.7494 6.77855 10.8585 6.85531 11.0668C7.04315 11.5765 7.36239 12.0322 7.78325 12.3914C8.20411 12.7506 8.71287 13.0016 9.26206 13.1209C9.81125 13.2402 10.383 13.224 10.9239 13.0738C11.4648 12.9235 11.9572 12.6442 12.3553 12.2618L12.3609 12.2565L12.3646 12.253L13.5314 11.2003Z"
        fill="url(#paint1_linear_1819_4286)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1819_4286"
          x1="1.49012e-07"
          y1="10"
          x2="20"
          y2="10"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A6CCDC" />
          <stop offset="1" stopColor="#C0E9FA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1819_4286"
          x1="5"
          y1="10"
          x2="15"
          y2="10"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E5EFF3" />
          <stop offset="1" stopColor="#89B3C5" />
        </linearGradient>
      </defs>
    </svg>
  );
}
